


















import {Component, Prop} from "vue-property-decorator";
import BaseDialog from "@/component/Dialog/base-dialog.vue";

@Component({})
export default class DeleteDialog extends BaseDialog {
    @Prop() objName!: string | undefined
    @Prop() protected cancelText!: string | undefined
    @Prop() protected confirmText!: string | undefined
}
